import React, { Component } from 'react';
import { Link } from 'react-router';
import styles from '../css/Main.css';
import Navigation from '../components/Navigation.js';

import photo1 from '../../design/photos/neriage/_HUM2685.jpg';
import photo2 from '../../design/photos/neriage/_HUM2691 - Farbe.jpg';
import photo3 from '../../design/photos/neriage/DSCN0460Farbe.jpg';
import photo4 from '../../design/photos/neriage/otherVersion/P1010972B.jpg';
import photo5 from '../../design/photos/neriage/_HUM2694 - Farbe - Kopiegedreht.jpg'; 
import photo6 from '../../design/photos/neriage/N4.jpg';
import photo7 from '../../design/photos/neriage/N3.jpg';
import photo8 from '../../design/photos/neriage/N1.jpg';
import photo9 from '../../design/photos/neriage/nf6-Big.JPG';
import photo10 from '../../design/photos/neriage/P1010949.jpg';

import arrow from '../../design/photos/arrow.jpg';

// H 9/9.5/7 cm
export default class Neriage extends Component {
  constructor() {
    super();
    this.state = {
      count: 0,
      photocount: 0,
      photo: [photo2, photo3, photo4, photo6, photo7, photo8, photo10],
      what: [
        'Neriage', 'z.T. Neriage', 'z.T. Neriage',
        'Neriage', 'Neriage', 'Neriage',
        '',
      ],
      size: [
        'D 14 cm', 'H 9/9.5/7 cm', 'H 13 cm, D 7 cm',
        'D 12/15 cm', 'D 22 cm', 'H 17 cm', 
        '',
      ],
      photographer: [
        'Foto: Tobias Humm', 'Foto: HS', 'Foto: HS',
        'Foto: Hugo Jeger', 'Foto: Hugo Jeger', 'Foto: Hugo Jeger', 
        'Foto: HS',
      ],
    };
  }

  getImage() {
    return (
      <button onClick={() => this.bigPicture()} className={styles.button2}>
        <img
          alt={10}
          className={styles.photoSideshow}
          src={this.state.photo[this.state.photocount]}
        />
      </button>
    );
  }

  bigPicture() {
    this.setState({count: 2});
  }

  backToSlideshow() {
    this.setState({count: 1});
  }

  increment() {
    if (this.state.photocount === 6) {
      this.setState({ photocount: 0 });
    } else {
      this.setState({ photocount: this.state.photocount + 1 });
    }
  }

  decrement() {
    if (this.state.photocount === 0) {
      this.setState({ photocount: 6 });
    } else {
      this.setState({ photocount: this.state.photocount - 1 });
    }
  }

  handleClick(a) {
    if (this.state.count === 0) {
      this.setState({ count: 1 });
      this.setState({ photocount: a });
    } else {
      this.setState({ count: 0 });
    }
  }

  render() {
    if (this.state.count === 0) {
      return (
        <div className={styles.container}>
          <div className={styles.header}>
            <p className={styles.titleleft}>Hanna Schneider</p>
            <p className={styles.titleright}>Keramik</p>
          </div>
          <div className={styles.content}>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(0)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo2} />
              </button>
              <button onClick={() => this.handleClick(4)} className={styles.button2}>
                <img alt={1} className={styles.photos} src={photo7} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(1)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo3} />
              </button>
              <button onClick={() => this.handleClick(5)} className={styles.button2}>
                <img alt={1} className={styles.photos} src={photo8} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(2)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo4} />
              </button>
              <button onClick={() => this.handleClick(6)} className={styles.button2}>
                <img alt={1} className={styles.photos} src={photo10} />
              </button>
            </div>

            <div className={styles.row1}>
              <button onClick={() => this.handleClick(3)} className={styles.button}>
                <img alt={1} className={styles.photos} src={photo6} />
              </button>
            </div>
          </div>
          <Navigation />
        </div>
      );
    }
    if (this.state.count == 1) {
      return (
        <div className={styles.container}>
          <div className={styles.header}>
            <p className={styles.titleleft}>Hanna Schneider</p>
            <p className={styles.titleright}>Keramik</p>
          </div>
          <div className={styles.sideShowContainer}>
            <div className={styles.sideshowArea}>
              <button className={styles.buttonSideshow} onClick={() => this.decrement()}>
                <img alt={10} className={styles.imgSideshow} src={arrow} />
              </button>
                {this.getImage()}
              <button className={styles.buttonSideshow} onClick={() => this.increment()}>
                <img alt={10} className={styles.imgSideshow2} src={arrow} />
              </button>
            </div>
            <div className={styles.footer}>
              <div className={styles.descriptionArea}>
                <Link className={styles.link} to="arbeiten">
                  <button className={styles.back} onClick={() => this.handleClick(0)}>Zurück</button>
                </Link>
              </div>
              <div className={styles.descriptionArea}>
                <p className={styles.description}>{this.state.what[this.state.photocount]}</p>
                <p className={styles.description}>{this.state.size[this.state.photocount]}</p>
                <p className={styles.description}>{this.state.photographer[this.state.photocount]}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.bigImageArea}>
        <div className={styles.imageContainer}>
          <img
            className={styles.bigImage}
            alt={10}
            src={this.state.photo[this.state.photocount]}
          />
        </div>
        <button className={styles.bigBack} onClick={() => this.backToSlideshow()}> Zurück </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Neriage.js